import React, { FC, PropsWithChildren, useEffect, useState } from 'react'
import { setAlgoliaQueryIDInLocalStorage } from 'lib/algolia/v2/helpers'
import LayoutConnector, { ConnectorProps as LayoutProps } from '../connectors/Layout'
import ModalConnector, { ConnectorProps as ModalConnectorProps } from 'connectors/Modal'
import PaginationHitsPerPageLayout from './PaginationHitsPerPage'
import UserPolaroids from '../components/UserPolaroids/UserPolaroids'
import ArtworkFilters from './ArtworkFilters'
import styles from './UserArtworks.module.scss'
import ArtistInfo from '../components/Header/ArtistInfo'
import classNames from 'classnames'
import Modal from 'components/SA/Modal/v2'
import useIsMobile from 'hooks/useIsMobile'
import ArtistSeriesCarousel from '../components/ArtistSeriesCarousel'

const FiltersParent: FC<PropsWithChildren> = ({ children }) => {
  const isMobileScreen = useIsMobile()

  if (!isMobileScreen) {
    return children
  }

  return (
    <Modal
      name='artistAllArtworksFilters'
      layout='standard'
      styleOverride={styles.mobileFiltersModal}
      isCloseButtonVisible
    >
      <div className={styles.mobileFiltersModalContent}>{children}</div>
    </Modal>
  )
}

type UserArtworksProps = LayoutProps & ModalConnectorProps

const UserArtworks: FC<UserArtworksProps> = ({ queryID, openModal, closeModal }) => {
  const [isFiltersVisible, setIsFiltersVisible] = useState(true)

  const handleOpenMobileFilter = () => {
    openModal('artistAllArtworksFilters')
  }

  useEffect(() => {
    // store ALGOLIA_QUERY_ID in local storage
    setAlgoliaQueryIDInLocalStorage(queryID)
  })

  return (
    <div className={styles.allArtworksWrapper}>
      <div className={styles.userArtworkInfoContainer}>
        <ArtistInfo
          isFiltersVisible={isFiltersVisible}
          setIsFiltersVisible={setIsFiltersVisible}
          onOpenMobileFilter={handleOpenMobileFilter}
        />
      </div>

      <div className={styles.mainContentGrid}>
        <div
          className={classNames(styles.left, {
            [styles.hiddenGrid]: !isFiltersVisible,
          })}
        >
          <FiltersParent>
            <ArtworkFilters setIsFiltersVisible={setIsFiltersVisible} closeModal={closeModal} />
          </FiltersParent>
        </div>
        <div
          className={classNames(styles.right, {
            [styles.fullGrid]: !isFiltersVisible,
          })}
        >
          <UserPolaroids isFiltersVisible={isFiltersVisible} />
        </div>
      </div>

      <div className={styles.userArtworkPaddingContainer}>
        <PaginationHitsPerPageLayout />
        <ArtistSeriesCarousel />
      </div>
    </div>
  )
}

export default LayoutConnector(ModalConnector(UserArtworks))
